import { render, staticRenderFns } from "./center-editor.vue?vue&type=template&id=4f2a7932&scoped=true&"
import script from "./center-editor.vue?vue&type=script&lang=js&"
export * from "./center-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2a7932",
  null
  
)

export default component.exports